import './add_categorie_modal.css'
import React, { useState} from 'react'
import Button from '@mui/material/Button';
import swal from 'sweetalert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {makeStyles} from '@mui/styles';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import InputAdornment from '@mui/material/InputAdornment';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { add_categorie } from '../../../../services/company_admin_service';


const useStyles = makeStyles((theme) => ({
    button: { margin: 8,},
    root: {
      '& > *': {
        margin: 8,
      },
    }
  }));

function Add_categorie_modal({add_categorie_modal,setadd_categorie_modal,setCategorie_added,update_categorie,setupdate_categorie}){

    const classes = useStyles();

    const [errorText,setErrorText] = useState("");

    const [categorie,setcategorie]=useState(update_categorie?update_categorie.name:'');

    const [waiting,setWaiting] = useState(false)

    function submit(){
        setErrorText('');
        if(categorie==="") setErrorText('Champs invalides !');
        else{
            swal({
                title: "Etes-vous sûr ?",
                text: "!!!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then((willDelete) => {
              if (willDelete) {
                setWaiting(true);
                let formData = new FormData();
               if(update_categorie) formData.append('id_category',update_categorie.id_category);
                formData.append('categorie',categorie);
                add_categorie(formData).then((response) => {
                  setWaiting(false);
                  if(update_categorie){
                    swal("La Famille d'achat a été modifiée avec succès !", {
                      icon: "success",
                      buttons: true,
                      }).then((willDelete) => {
                          if (willDelete) {
                              
                          }
                      })
                      setupdate_categorie(null);
                  }else{
                    swal("La Famille d'achat a été ajoutée avec succès !", {
                      icon: "success",
                      buttons: true,
                      }).then((willDelete) => {
                          if (willDelete) {
                              
                          }
                      })
                  }
                    setadd_categorie_modal(false);
                    setCategorie_added(response.data);
                }).catch((error) => {
                    //console.log(error.response);
                    let error_data = error.response.data;
                    if(error_data.errors){
                        if(error_data.errors.categorie) setErrorText("Famille déjà existant !");
                    }
                    setWaiting(false);
                });
              }
            })
        }
    }

    return (
      <Dialog fullWidth={true} maxWidth={'md'} open={add_categorie_modal} onClose={()=>{setupdate_categorie(null);setadd_categorie_modal(false)}} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">
        {!update_categorie?"Ajouter votre Famille d'achat":"Modifier votre Famille d'achat"}
        </DialogTitle>
        <DialogContent>
          <div className="add_categorie_modal_infos">
                <TextField variant='standard' className={classes.margin} label="Famille" style={{width:"250px"}} value={categorie}
                    InputProps={{ startAdornment: ( <InputAdornment position="start"> <BookmarkIcon  /> </InputAdornment> ), }} onChange={(e)=>setcategorie(e.target.value)} />
          </div>
        </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
                <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={()=>{setupdate_categorie(null);setadd_categorie_modal(false)}}>
                    Annuler
                </Button>
                <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon />} onClick={submit} >
                   {update_categorie?"Modifier":'Ajouter'}
                </Button>  
            </div>
               
          </div>
        </DialogActions>

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={waiting}
        >
            <CircularProgress color="inherit" />
        </Backdrop>

      </Dialog>
    )
}

export default Add_categorie_modal
